interface AdminSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function AdminSidebar({ activeTab, onTabChange }: AdminSidebarProps) {
  const tabs = [
    { id: 'accounts', label: 'Account Management', icon: 'ri-user-settings-line' },
    { id: 'discounts', label: 'Discount Codes', icon: 'ri-coupon-3-line' },
    { id: 'telegram', label: 'Telegram', icon: 'ri-telegram-line' },
    { id: 'landing_st', label: 'Landing.st Sync', icon: 'ri-plug-line' },
    { id: 'tour_products', label: 'Tour Products', icon: 'ri-suitcase-line' },
  ];

  return (
    <aside className="w-full lg:w-[300px] shrink-0">
      <div className="bg-white rounded-lg border border-secondary-200 p-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-secondary-900 text-white flex items-center justify-center shrink-0">
            <i className="ri-shield-star-line text-xl" />
          </div>
          <div className="min-w-0">
            <h2 className="font-heading text-lg font-bold text-secondary-900">Admin Panel</h2>
            <span className="inline-flex items-center gap-1 mt-0.5 text-xs font-semibold rounded-full px-2.5 py-0.5 whitespace-nowrap bg-secondary-900 text-white">
              <i className="ri-vip-crown-line" />
              Super Admin
            </span>
          </div>
        </div>

        <nav className="mt-6 space-y-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-center gap-3 text-sm font-medium rounded-md px-4 py-2.5 transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? 'bg-primary-500 text-white'
                  : 'text-secondary-700 hover:bg-secondary-100'
              }`}
            >
              <i className={`${tab.icon} text-base`} />
              {tab.label}
            </button>
          ))}
        </nav>

        <p className="mt-6 text-xs leading-relaxed text-secondary-400 border-t border-secondary-200 pt-4">
          Changes you make here are applied instantly. Travelers will see booking
          updates on their account without refreshing.
        </p>
      </div>
    </aside>
  );
}